import React from 'react';
import Modal from 'react-responsive-modal';

import Logger, {LOG_LEVELS} from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
const log = new Logger('APPLICATION_MESSAGE_DETAILS_MODAL', LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width'
};

class ApplicationMessageDetailsModal extends React.Component {

    constructor(props) {
        super(props);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    onCloseClick(event) {
        log.debug('onCloseClick(): event: ', event);
        this.props.onCloseClick();
    }

    render() {
        log.debug('render(): ', this.props);
        const {open} = this.props;
        const titleLanguageString = this.props.titleLanguageString ? this.props.titleLanguageString : 'applicationMessageDetailsModal_ErrorDetail';
        return (
            <div>
                <Modal center
                    classNames={MODAL_CLASSNAMES}
                    open={open}
                    closeOnOverlayClick={false}
                    onClose={this.onCloseClick}
                >
                    <h2><LanguageStringResolver string={titleLanguageString} /></h2>
                    {this.props.children}
                </Modal>
            </div>
        );
    }
}


ApplicationMessageDetailsModal.defaultProps = {
    open: false,
    onCloseClick: () => {},
    titleLanguageString: ''
}

export default ApplicationMessageDetailsModal;
